import { utils as appMainUtils } from '@edf-pkg/app-main';

import { axios } from '$app-web/api/axios';
import { ObjectType } from '$app-web/types';

import { Endpoints } from '../constant';

export async function sendParticipantHistoryReport(message: ObjectType, sessionUUID: string | null = null) {
    const { id, deviceId } = appMainUtils.user.getData();
    const formData = new FormData();

    try {
        formData.append('tag', 'ph');
        formData.append('message', JSON.stringify(message));
        formData.append('device_id', deviceId || 'anonymous');
        if (id != null) {
            formData.append('user_id', id);
        }
        if (sessionUUID != null) {
            formData.append('session_uuid', sessionUUID);
        }

        const { status } = await axios.post(Endpoints.ParticipantHistoryReport, formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        });

        return status === 200;
    } catch {
        return false;
    }
}
